import { render } from "./Pallet Sizes.vue?vue&type=template&id=2a87d3e2"
import script from "./Pallet Sizes.vue?vue&type=script&lang=js"
export * from "./Pallet Sizes.vue?vue&type=script&lang=js"

import "./Pallet Sizes.vue?vue&type=style&index=0&id=2a87d3e2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__